import React from 'react'
import { withTranslation } from 'react-i18next';
import loadable from "@loadable/component";

import WholeScreenLoader from '~/components/whole-screen-loader';

import logic from './logic'

const LoadableCart = loadable(() => import(/* webpackChunkName: "cart" */ './cart'), {fallback: <WholeScreenLoader />});
const LoadableCheckout = loadable(() => import(/* webpackChunkName: "checkout" */ './checkout'), {fallback: <WholeScreenLoader />});
const LoadableCartButton = loadable(() => import(/* webpackChunkName: "cart-button" */ '~/components/cart-button'), {fallback: <WholeScreenLoader />});

@withTranslation('cart')
@logic
export default class App extends React.PureComponent {

  handleCartButtonClick = () => {
    const { openCart } = this.props.actions;

    openCart()
  };

  noHideUrl = () => {
    if(typeof window !== 'undefined') {
      if(/[?&]hidegfy=/.test(location.search)) {
        return false
      }
    }

    return true;
  }

  render() {
    const {
      cartVisible,
      cartButtonVisible,
      cartButtonAlignment,
      openingCart,
      cartItemsCount,
      showTaxNotice,
      showShipping,
      showDiscount,
      showServiceFee,
      nextStep,
      checkoutVisible,
      loading
    } = this.props;
    const { closeCart, next, previous } = this.props.actions;

    return [
      cartVisible && this.noHideUrl() ?
        <LoadableCart
          key='cart'
          visible={ cartVisible }
          closeCart={ closeCart }
          count={ cartItemsCount }
          showTaxNotice={ showTaxNotice }
          showShipping={ showShipping }
          showDiscount={ showDiscount }
          showServiceFee={ showServiceFee }
          next={ next }
          loading={ loading }
        /> : null,

      checkoutVisible && this.noHideUrl() ? <LoadableCheckout key='checkout' previous={ previous } visible={ checkoutVisible }/> : null,
      cartButtonVisible ? <LoadableCartButton key='cart-button' onClick={ this.handleCartButtonClick } loading={ openingCart } count={ cartItemsCount } cartButtonAlignment={ cartButtonAlignment }/> : null,
    ]
  }
}
